import { render, staticRenderFns } from "./WeekInAreaChars.vue?vue&type=template&id=bd0aa02e&scoped=true";
import script from "./WeekInAreaChars.vue?vue&type=script&lang=js";
export * from "./WeekInAreaChars.vue?vue&type=script&lang=js";
import style0 from "./WeekInAreaChars.vue?vue&type=style&index=0&id=bd0aa02e&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "bd0aa02e", null);
export default component.exports;